import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@teach/ui'
import type { Lang } from '@/types/lang'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  /** Какой язык удаляем; `null` — диалог закрыт. */
  lang: Lang | null
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isDeleting: boolean
  /** Куда вернуть фокус: пункт меню, открывший диалог, уже размонтирован. */
  onCloseAutoFocus?: (e: Event) => void
}

/** Удаление языка необратимо (спека §07, контракт §6.9) — последствие
 *  называем словами. Файлы картинок и видео не удаляются, только отвязываются. */
export const DeleteLanguageDialog = ({
  lang,
  onOpenChange,
  onConfirm,
  isDeleting,
  onCloseAutoFocus,
}: Props) => {
  const m = useMessages(messages)
  return (
    <AlertDialog open={lang !== null} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-lg" onCloseAutoFocus={onCloseAutoFocus}>
        <AlertDialogHeader>
          <AlertDialogTitle>{m.deleteLangTitle(lang)}</AlertDialogTitle>
          <AlertDialogDescription>{m.deleteLangBody}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{m.cancel}</AlertDialogCancel>
          <AlertDialogAction
            disabled={isDeleting}
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {m.delete}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
